import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SignInScreen from '../components/SignInScreen/SignInScreen';

export default function SignInPage({ mode = 'signin' }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Already authenticated → go to lobby
  useEffect(() => {
    if (user) navigate('/lobby', { replace: true });
  }, [user, navigate]);

  return (
    <div style={{ background: '#14150D', minHeight: '100dvh' }}>
      <SignInScreen
        initialMode={mode}
        onSignInSuccess={() => navigate('/lobby', { replace: true })}
      />
    </div>
  );
}
